import { AbstractControl } from "@angular/forms";

export function nonCyrillicValidator(control: AbstractControl): { nonCyrillic?: boolean } | null {
	const value = String(control.value);
	const cyrillicRegex = /[а-яА-ЯЁё]/;

	if (value.match(cyrillicRegex)) {
		return { nonCyrillic: false };
	}

	return null;
}
